import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Input, Typography, Row, Col } from 'antd';
import { useToast } from '../../contexts/ToastContext';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { apiService } from '../../services/api';
import '../../styles/colors.css';

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    let isValid = true;
    setEmailError('');

    if (!email) {
      setEmailError('E-posta adresinizi girin!');
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError('Geçerli bir e-posta adresi girin!');
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async (e?: React.MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const response = await apiService.forgotPassword(email);
      if (response.success) {
        setSuccess(true);
        toast.success('Şifre sıfırlama linki e-posta adresinize gönderildi!');
      } else {
        toast.error(response.message || 'Bir hata oluştu.');
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Bir hata oluştu. Lütfen tekrar deneyin.';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-shell" style={{ display: 'flex', minHeight: '100vh' }}>
      <Row style={{ width: '100%', minHeight: '100vh', margin: 0 }}>
        <Col
          xs={0}
          lg={12}
          className="auth-split-brand"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: 'white',
            zIndex: 2,
            width: '80%',
            maxWidth: '500px'
          }}>
            <div style={{
              width: '120px',
              height: '120px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 32px',
              fontSize: '3rem',
              fontWeight: 'bold',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(255,255,255,0.3)'
            }}>
              M
            </div>
            <Title level={1} style={{ 
              color: 'white',
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '16px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              Menteem
            </Title>
            <Text style={{ 
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.3rem',
              fontWeight: '500'
            }}>
              Şifrenizi mi unuttunuz?
            </Text>
          </div>
        </Col>

        <Col xs={24} lg={12} className="auth-split-form-column" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <div className="auth-mobile-brand">
            <div>
              <Text strong style={{ color: '#fff', fontSize: 17, display: 'block', lineHeight: 1.3 }}>Menteem</Text>
              <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13 }}>Şifre sıfırlama</Text>
            </div>
            <Link to="/login" className="auth-back-link auth-back-link--compact">
              <ArrowLeftOutlined /> Giriş
            </Link>
          </div>
          <div className="auth-form-card" style={{ width: '100%', maxWidth: '400px' }}>
            {!success ? (
              <>
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <Title level={2} style={{ 
                    marginBottom: '8px',
                    color: 'var(--text-primary)',
                    fontSize: '2.2rem',
                    fontWeight: '700'
                  }}>
                    Şifremi Unuttum
                  </Title>
                  <Text style={{ 
                    color: 'var(--text-secondary)',
                    fontSize: '1.1rem'
                  }}>
                    E-posta adresinizi girin, size şifre sıfırlama linki gönderelim
                  </Text>
                </div>

                <div>
                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ 
                      display: 'block', 
                      color: 'var(--text-primary)', 
                      fontWeight: '600', 
                      fontSize: '0.95rem',
                      marginBottom: '8px'
                    }}>
                      E-posta
                    </label>
                    <Input
                      prefix={<MailOutlined style={{ color: 'var(--primary-600)' }} />}
                      placeholder="E-posta adresiniz"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ 
                        borderRadius: '12px',
                        height: '50px',
                        fontSize: '1rem'
                      }}
                    />
                    {emailError && (
                      <div style={{ color: 'var(--error)', fontSize: '0.875rem', marginTop: '4px' }}>
                        {emailError}
                      </div>
                    )}
                  </div>

                  <button
                    type="button"
                    className="btn-primary"
                    disabled={loading}
                    onClick={handleSubmit}
                    style={{
                      width: '100%',
                      height: '52px',
                      borderRadius: '12px',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      border: 'none',
                      cursor: 'pointer',
                      marginBottom: '24px'
                    }}
                  >
                    {loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Linki Gönder'}
                  </button>
                </div>
              </>
            ) : (
              <Card className="app-content-card" style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: '24px' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: '#f0fdf4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    fontSize: '2.5rem'
                  }}>
                    ✓
                  </div>
                  <Title level={3} style={{ marginBottom: '16px' }}>
                    E-posta Gönderildi!
                  </Title>
                  <Text style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                    Eğer bu e-posta adresi sistemde kayıtlıysa, şifre sıfırlama linki ve doğrulama kodu gönderilmiştir. 
                    Lütfen e-posta kutunuzu kontrol edin.
                  </Text>
                </div>
                <Button
                  type="primary"
                  onClick={() => navigate('/login')}
                  style={{
                    width: '100%',
                    height: '48px',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    fontWeight: '600'
                  }}
                >
                  Giriş Sayfasına Dön
                </Button>
              </Card>
            )}

            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <Link 
                to="/login" 
                style={{ 
                  color: 'var(--text-tertiary)',
                  fontSize: '0.95rem',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => (e.target as HTMLElement).style.color = 'var(--primary-600)'}
                onMouseLeave={(e) => (e.target as HTMLElement).style.color = 'var(--text-tertiary)'}
              >
                <ArrowLeftOutlined />
                Giriş sayfasına dön
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPassword;

